<template>
  <v-container id="schedule" fluid>
    <h1 class="primary--text mt-3">
      Programm
    </h1>

    <v-list
      class="schedule-list"
      style="background: transparent;"
    >
      <template v-for="(item, index) in items">
        <v-subheader
          v-if="item.header"
          :key="item.header"
        >
          {{ item.header }}
        </v-subheader>

        <v-divider
          v-else-if="item.divider"
          :key="index"
          :inset="item.inset"
        />

        <v-list-tile
          v-else
          :key="item.title"
          avatar
          class="py-2"
        >
          <v-list-tile-avatar
            v-if="item.avatar"
            :key="item.avatar"
          >
            <img :src="require('../assets/images/speaker/' + item.avatar)">
          </v-list-tile-avatar>

          <v-icon
            v-if="item.icon"
            :key="item.icon"
            large
            :color="item.iconColor"
            class="pr-3"
          >
            {{ item.icon }}
          </v-icon>

          <v-list-tile-content>
            <v-list-tile-title v-html="item.title" />
            <v-list-tile-sub-title v-html="item.subtitle" />
            <v-list-tile-sub-title
              v-if="item.room"
              class="mt-2"
            >
              <v-icon small :color="item.color">beenhere</v-icon> {{ item.room }}
            </v-list-tile-sub-title>
            <v-expansion-panel v-if="item.text">
              <v-expansion-panel-content>
                <template v-slot:header>
                  <div>Darum geht’s im Vortrag 👌</div>
                </template>
                <v-card>
                  <v-card-text
                    class="grey lighten-3"
                    v-html="item.text"
                  />
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-list-tile-content>
        </v-list-tile>
      </template>
    </v-list>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      items: [
        { header: '08:00' },
        {
          icon: 'label_important',
          iconColor: 'grey lighten-1',
          title: 'Registrierung und heißer Kaffee',
          room: 'Raum Aula',
          color: 'primary'
        },
        { header: '09:00' },
        {
          icon: 'label_important',
          iconColor: 'grey lighten-1',
          title: 'Eröffnung mit Grußwort',
          room: 'Raum Aula',
          color: 'primary'
        },
        { header: '09:30' },
        {
          id: 'tom-alby',
          avatar: 'tom-alby-avatar.jpg',
          title: 'Keynote – Warum digitale Transformation und 100 Jahre Traditionsunternehmen kein Widerspruch sind',
          subtitle: 'Tom Alby, Euler Hermes',
          room: 'Raum Aula',
          color: 'primary'
        },
        { header: '10:15' },
        {
          id: 'karl-kratz',
          avatar: 'karl-kratz-avatar.jpg',
          title: 'Die Kunst digitaler Berührung',
          subtitle: 'Karl Kratz, Karl Kratz Online Marketing',
          room: 'Raum Aula',
          color: 'primary',
          text: 'Was macht das Erleben mancher Websites so „besonders“? Wie heißt die Kraft, die uns Menschen dabei digital „berührt“?<br>Es ist eigentlich alles so einfach: Wer einzigartig wird – einzig in&nbsp;der Art – erhält eine wunderbare Eintrittskarte in die Aufmerksamkeit und Neugierde der Menschen.<br>„Die Kunst digitaler Berührung“ ist eine Reise an einen Ort echter Inspiration – für&nbsp;Menschen, die Mut und Lust auf Neues im Digitalen haben!'
        },
        { header: '11:00' },
        {
          icon: 'room_service',
          iconColor: 'grey lighten-1',
          title: '<strong>Pause – heißer Kaffee, knackiges Obst und frische Luft</strong>'
        },
        { header: '11:30' },
        {
          id: 'sarah-weitnauer',
          avatar: 'sarah-weitnauer-avatar.jpg',
          title: 'Psychologie rockt das Web',
          subtitle: 'Sarah Weitnauer, Psyketing',
          room: 'Raum Aula',
          color: 'primary',
          text: 'Psychologie auf Websites zu nutzen, heißt, Conversions zu generieren und potenzielle Kunden schneller für ein Unternehmen zu begeistern. Dabei kommt es auf das perfekte Zusammenspiel von Design, Text und erwünschter Wirkung an. Selten reichen Farben, Schriften und Bilder aus, oft braucht es wirksame psychologische Mechanismen wie Priming und Ankereffekte. Sarah Weitnauer spielt auf der Klaviatur der psychologischen Kniffe und zeigt in ihrem Vortrag zum Mitexperimentieren, wie die verschiedenen Mechanismen der Werbepsychologie auf Webseiten funktionieren und wirken.'
        },
        { header: '12:15' },
        {
          id: 'rima-rifai',
          avatar: 'rima-rifai-avatar.jpg',
          title: 'Die Macht der Düfte im Marketing – wie der Duft einer Marke Onlinekunden bindet',
          subtitle: 'Rima Rifai, Die Duftmanufaktur',
          room: 'Raum Aula',
          color: 'primary'
        },
        {
          id: 'sven-deutschlaender',
          avatar: 'sven-deutschlaender-avatar.jpg',
          title: 'Onlinemarketing leicht(er) gemacht – 10 Profi-Tipps für deinen Marketing Alltag',
          subtitle: 'Sven Deutschländer, SEO-Profi Berlin',
          room: 'Raum Konzil',
          color: 'accent'
        },
        { header: '13:00' },
        {
          icon: 'room_service',
          iconColor: 'grey lighten-1',
          title: '<strong>Mittagspause – kühle Erfrischung, köstliches Fingerfood und viel Zeit zum Austausch</strong>'
        },
        { header: '14:15' },
        {
          id: 'martin-horst',
          avatar: 'martin-horst-avatar.jpg',
          title: 'Von der Kreativagentur zur Eismanufaktur. Über Höhen und Tiefen dieser eiskalten Liebesbeziehung',
          subtitle: 'Martin Horst, Jackle & Heidi',
          room: 'Raum Aula',
          color: 'primary'
        },
        {
          id: 'katja-wolter',
          avatar: 'katja-wolter-avatar.jpg',
          title: 'Mit Self Publishing von der Idee zum (digitalen) Buch – Erfahrungen und Tipps',
          subtitle: 'Katja Wolter, Steinbeis-Institut für Ressourcen-Entwicklung',
          room: 'Raum Konzil',
          color: 'accent'
        },
        { header: '15.00' },
        {
          id: 'maximilian-block',
          avatar: 'maximilian-block-avatar.jpg',
          title: 'advocado – von einer Idee zum ausgezeichneten, digitalen Startup in MV',
          subtitle: 'Maximilian Block, advocado GmbH',
          room: 'Raum Aula',
          color: 'primary'
        },
        {
          id: 'christiane-sohn',
          avatar: 'christiane-sohn-avatar.jpg',
          title: 'Aufgeweckter Content – Tipps und Tools, mit denen Du Online-Texte verständlicher und leichter lesbar machst',
          subtitle: 'Christiane Sohn, CS Communication',
          room: 'Raum Konzil',
          color: 'accent'
        },
        { header: '15:45' },
        {
          icon: 'room_service',
          iconColor: 'grey lighten-1',
          title: '<strong>Pause – heißer Kaffee, feine Küchlein und leckeres Eis</strong>'
        },
        { header: '16.15' },
        {
          id: 'frank-trettin',
          avatar: 'frank-trettin-avatar.jpg',
          title: 'Der Barfüßler – eine authentische, online und offline Erfolgsgeschichte in Barfuß-Schuhen',
          subtitle: 'Frank Trettin, Barfüßler Greifswald',
          room: 'Raum Aula',
          color: 'primary'
        },
        {
          id: 'annelie-baensch',
          avatar: 'annelie-baensch-avatar.jpg',
          title: 'Social Media Workshop',
          subtitle: 'Annelie Bänsch, vonAhoi',
          room: 'Raum Konzil',
          color: 'accent'
        },
        { header: '17:00' },
        {
          icon: 'local_bar',
          iconColor: 'light-green',
          title: '<strong>Erfrischung, Imbiss und viel Zeit zum Austausch</strong>'
        }
      ]
    }
  }
}
</script>

<style lang="scss">
.schedule-list {
  .v-subheader {
    padding: 0;
    &:not(:first-child) {
      margin-top: 16px;
    }
  }

  [role="listitem"] + [role="listitem"] {
    margin-top: 16px;
  }

  .v-list__tile--avatar {
    height: auto;
    padding: 0;
  }

  .v-list__tile__content {
    overflow: auto;
  }

  .v-list__tile__title,
  .v-list__tile__sub-title {
    height: auto;
    white-space: normal;
    overflow: auto;
  }

  .v-expansion-panel {
    box-shadow: none;
  }

  .v-expansion-panel__header {
    padding-left: 0;
  }
}
</style>
